import { Documents_Power_Of_Attorneys } from '@/__generated__/graphql';
import { TypedDocumentNode, gql } from '@apollo/client';

export type DocumentPowerOfAttorney = Pick<
  Documents_Power_Of_Attorneys,
  'user_id' | 'company_id'
>;
export type CompaniesPowerOfAttorneys = {
  documents_power_of_attorneys: DocumentPowerOfAttorney[];
};
export type CompaniesPowerOfAttorneysVariables = {
  companiesIds: number[];
  userId: number;
};
export const getCompaniesPowerOfAttorneysQuery = gql`
  query getCompaniesPowerOfAttorneys($companiesIds: [Int!], $userId: Int!) {
    documents_power_of_attorneys(
      where: {
        _and: { company_id: { _in: $companiesIds }, user_id: { _eq: $userId } }
      }
    ) {
      user_id
      company_id
    }
  }
` as TypedDocumentNode<
  CompaniesPowerOfAttorneys,
  CompaniesPowerOfAttorneysVariables
>;
